import { flattenCategories } from './utils';
import { ContentTypes } from '~/types/adamTypes';
import type { ExerciseInfoSchema } from '~/types/schema';
import { Sections } from '~/types/ui';

export const getExercisesByCategories = (categories, content, memberId) => {
  content.basePath = `/${Sections.Revisions}`;
  content.path = `${content.basePath}/${content.slug}`;

  const _getCategoriesWithExercisesDeep = (
    category,
    categories = [],
    chapterId = null
  ) => {
    category.chapterId = chapterId;
    if (category.exercises && category.exercises.length) {
      categories.push(category);
    }
    if (category.children && category.children.length > 0) {
      category.children = category.children.filter((child) => {
        return child.contentType !== ContentTypes.Extra;
      });
      category.children.forEach((child) => {
        if (child.contentType === ContentTypes.Chapter) {
          chapterId = child.id;
        }
        const cats = _getCategoriesWithExercisesDeep(child, [], chapterId);
        categories = [...categories, ...cats];
      });
    }
    return categories;
  };
  const reduce = (
    categories
  ): {
    title: string;
    id: string;
    mediaIcon: string;
    exercises: ExerciseInfoSchema[];
  }[] => {
    const disciplines = [];
    categories.forEach((category) => {
      const categories = _getCategoriesWithExercisesDeep(category);
      // let discipline;
      if (categories.length) {
        const discipline = {
          title: category.title,
          id: category.id,
          mediaIcon: category.mediaIcon,
          exercises: [],
          path: `${content.path}/${category.slug}`,
        };
        categories.forEach((cat) => {
          cat.exercises.forEach((exercise) => {
            discipline.exercises.push({
              basePath: `${content.path}/${cat.slug}`,
              chapterId: cat.chapterId,
              disciplinePath: discipline.path,
              title: exercise.title,
              id: exercise.id,
              libraryBookId: content.id,
              disciplineId: discipline.id,
              disciplineTitle: discipline.title,
              mediaIcon: discipline.mediaIcon,
              memberId,
              isfinished: false,
              score: 0,
              points: 0,
              maxPoints: exercise.maxPoints,
            });
          });
        });
        if (discipline) {
          disciplines.push(discipline);
        }
      }
    });
    return disciplines;
  };
  return reduce(categories);
};

export const retrieveDeepFromCategoryExerciseIds = (
  category: CategorySchema
) => {
  const cats = flattenCategories(category);
  const exerciseIds = cats.reduce<string[]>((acc, cat) => {
    if (cat.exercises) {
      const exerciceIds = cat.exercises.map((ex) => ex.id);
      acc = [...acc, ...exerciceIds];
    }
    return acc;
  }, [] as string[]);
  return exerciseIds;
};
